import React from 'react';
import { useTranslation } from 'react-i18next';
import TableCell from '@mui/material/TableCell';
import { useUnpublishMinisitePagesMutation } from '../../../../graphql/mutation/minisite/minisitePage/unpublishMinisitePagesMutation';
import { usePublishMinisitePagesMutation } from '../../../../graphql/mutation/minisite/minisitePage/publishMinisitePagesMutation';
import useNotification from '../../../components/_hook/useNotification';
import StatusIconButton from '../../../components/_iconButton/StatusIconButton';
import useRouter from '../../../components/_hook/useRouter';
import { IMinisiteSchema } from '../../../../graphql/type/minisite';

interface IProps {
  item: IMinisiteSchema['configuration']['pages'][0];
}

export default function MinisitePageTableItem(props: IProps) {
  const { t } = useTranslation();
  const { item } = props;
  const { notification } = useNotification();
  const { params } = useRouter();
  const { docID: minisiteId } = params;
  const [
    publishMinisitePagesMutation,
    { loading: isPublishingMinisitePages },
  ] = usePublishMinisitePagesMutation(
    `updatedMinisite {
				_id
				configuration {
                  pages {
                    page
                    status
                  }
                }
			}`,
    {
      onError: (e) => {
        notification.error(e.message);
      },
    }
  );
  const [
    unpublishMinisitePagesMutation,
    { loading: isUnpublishingMinisitePages },
  ] = useUnpublishMinisitePagesMutation(
    `updatedMinisite {
				_id
				configuration {
                  pages {
                    page
                    status
                  }
                }
			}`,
    {
      onError: (e) => {
        notification.error(e.message);
      },
    }
  );

  async function onClickPublish() {
    await publishMinisitePagesMutation({
      variables: {
        minisiteId,
        pages: [item.page],
      },
    });
  }

  async function onClickUnpublish() {
    await unpublishMinisitePagesMutation({
      variables: {
        minisiteId,
        pages: [item.page],
      },
    });
  }

  return (
    <>
      <TableCell align="left">{t(item.page)}</TableCell>
      <TableCell align="right">
        <StatusIconButton
          status={item.status}
          loading={isUnpublishingMinisitePages || isPublishingMinisitePages}
          tooltip={item.status ? t('publish') : t('unpublish')}
          onClick={item.status ? onClickUnpublish : onClickPublish}
        />
      </TableCell>
    </>
  );
}
